import type { ComponentProps, FC } from 'react';
import { cn } from '../lib/utils';

type ChatHistoryActionButtonProps = Omit<ComponentProps<'button'>, 'aria-label'> & {
  /** Accessible name; also the hover title. */
  label: string;
};

/** A small icon button on a history row: pin, archive, more. */
export const ChatHistoryActionButton: FC<ChatHistoryActionButtonProps> = ({
  label,
  className,
  ...props
}) => (
  <button
    type="button"
    aria-label={label}
    title={label}
    className={cn(
      'flex size-7 shrink-0 cursor-pointer items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-surface-active hover:text-foreground [&_svg]:size-3.5',
      className
    )}
    {...props}
  />
);
